
/**
 * JavaScript React Framework
 */
import React from 'react';
// import ReactDom from 'react-dom';

/**
 * React-Bootstrap
 */ 
import { Media, Panel, Button, Grid, Row, Col } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import AppCarousel from '../carousel/AppCarousel.js';
import MarketingBlock from '../../common/content/MarketingBlock.js';
/* import MarketingMediaBlock from '../../common/content/MarketingMediaBlock.js'; */

import mediaImg_01 from '../../../assets/img/home/media_100x100_purple.png'
import mediaImg_02 from '../../../assets/img/home/media_100x100_blue.png'
import mediaImg_03 from '../../../assets/img/home/media_100x100_lightpurple.png'
import mediaImg_04 from '../../../assets/img/home/media_100x100_lightblue.png'

import mediaImg_05 from '../../../assets/img/home/media_100x100_turquise.png'
import mediaImg_06 from '../../../assets/img/home/media_100x100_lightturquise.png'

let fontSize = {fontSize: '1.10em'};

/**
 * Note: Your components tell React what you want to render
 */
class Home extends React.Component {
	render() {
		return (
			<div id="Homepage">
				<AppCarousel />
				
				<p/>

				<Grid className="blockpadding">
					<Row>
						<Col xs={6} md={2}>
							<Button className="stretch" href="http://shop.oreilly.com/product/9780596528393.do">O'Reilly Work</Button>
						</Col>

						<Col xs={6} md={2}>
							<Button className="stretch" href="/index.html#page=KarnaRam">Karna-Ram</Button>
						</Col>

						<Col xs={6} md={2}>
							<Button className="stretch" href="/index.html#page=Informatics">Informatics</Button>
						</Col>

						<Col xs={6} md={2}>
							<Button className="stretch" href="/index.html#page=LMS">LMS Project</Button>
						</Col>

						<Col xs={6} md={2}>
							<Button className="stretch" href="index.html#page=Engineering">Engineering</Button>
						</Col>

						<Col xs={6} md={2}>
							<Button className="stretch" href="/index.html#page=ITBuildOut">IT Build-Out</Button>
						</Col>
					</Row>
				</Grid>

		    <p/>

	    	<Grid className="blockpadding">
	    		<div className="well">
	    			<Row>
	    				<Col xs={12} md={12}>
			    			<Panel>
			    				<p className="text-muted text-justify">

			    					{ /* [Begin Media] */ }

			    					<Media>
			    						{
				    						/**
				    						 * Informatics & Cryptology [Begin]
				    						 */
				    					}

			    						<Media.Left>
								        <img width={75} height={75} src={mediaImg_01} alt="Thumbnail 01" />
								      </Media.Left>

								      <Media.Body>
								      	<Media.Heading>Informatics &amp; Cryptology</Media.Heading>
								      	<p style={fontSize}>
								      		I believe there is a place in medicine for <a href="https://en.wikipedia.org/wiki/Cryptography">cryptology</a> and that <a href="https://en.wikipedia.org/wiki/Informatics">informatics</a> can be extended to support certain cryptographic techniques to support the scientific investigation of disease. Specifically, Unicity Distance provides a scientific statistic for guiding quality of care.
								      	</p>

												<Media>
					    						<Media.Left>
										        <img width={75} height={75} src={mediaImg_03} alt="Thumbnail 02" />
										      </Media.Left>

										      <Media.Body>
										      	<Media.Heading>Biomedical Informatics</Media.Heading>
										      	<p style={fontSize}>
										      		Supporting this statement is my work in <a href="https://en.wikipedia.org/wiki/Health_informatics">biomedical informatics</a> using ICD-10-CM as a valid <a href="https://en.wikipedia.org/wiki/Cryptosystem">cryptosystem</a> supporting what's known as the <a href="https://en.wikipedia.org/wiki/Unicity_distance">unicity distance</a> in <a href="https://en.wikipedia.org/wiki/Information_theory">information theory</a> whereby a biomedical unicity distance defines a quantitative value for uncertainty in the interpretation of biomedical data - <a href="/index.html#page=KarnaRam">Karna-Ram</a> illustrates this work.
										      	</p>
										      </Media.Body>
					    					</Media>

												<Media>
					    						<Media.Left>
										        <img width={75} height={75} src={mediaImg_03} alt="Thumbnail 02" />
										      </Media.Left>

										      <Media.Body>
										      	<Media.Heading>Brownian Informatics</Media.Heading>
										      	<p style={fontSize}>
										      		Architect for an information and informatics draft technology based on a fundamental shift in the process of information transformation and growth. Brownian informatics is a substitution-based specification and technique for the dynamic study of information that originates from advancements in cryptography.
										      	</p>
										      </Media.Body>
					    					</Media>

								      </Media.Body>

								      {
				    						/**
				    						 * Astronomy [Begin]
				    						 */
				    					}

				    					<Media>
				    						<Media.Left>
									        <img width={75} height={75} src={mediaImg_05} alt="Thumbnail 05" />
									      </Media.Left>

									      <Media.Body>
									      	<Media.Heading>Gravitational Fusion, Energy & Astronomy</Media.Heading>
									      	<p style={fontSize}>
									      		Outside medicine and cryptography, I am drawn to <a href="https://www.as.arizona.edu">Astronomy</a> and the fundamental nature of energy and fusion; specifically the gravitational component igniting star energy production. This interest evolved from insights into <a href="https://www.llnl.gov">Lawrence Livermore National Laboratory</a> and the science behind a very complicated physics associated with energy.
									      	</p>

									      	<Media>
						    						<Media.Left>
											        <img width={75} height={75} src={mediaImg_06} alt="Thumbnail 06" />
											      </Media.Left>

											      <Media.Body>
											      	<Media.Heading>Propulsion Insights from Star Formation</Media.Heading>
											      	<p style={fontSize}>
											      		I find myself wondering what is that minimum point from which gravitational fusion is made possible and can manmade <a href="https://lasers.llnl.gov/science/icf/how-icf-works">pressurized forces</a> come to bear on the production of <a href="https://lasers.llnl.gov/science/energy-for-the-future">energy</a> and <a href="https://www.jpl.nasa.gov">propulsion</a> in a meaningful way with the aid of very high power <a href="https://lasers.llnl.gov/science/photon-science/arc">laser</a> systems in the presence of hydrogen under extreme pressure as a fundamental leap in propulsion technology.
											      	</p>

											      </Media.Body>
						    					</Media>

									      </Media.Body>
				    					</Media>

								      {
								      	/**
												 * Portfolio Website [Begin]
								      	 */
								      }

											<Media>
				    						<Media.Left>
									        <img width={75} height={75} src={mediaImg_02} alt="Thumbnail 03" />
									      </Media.Left>

									      <Media.Body>
									      	<Media.Heading>Portfolio Website</Media.Heading>
									      	<p style={fontSize}>
									      		Portfolio website designed with <a href="https://reactjs.org/">React.js</a>, <a href="https://react-bootstrap.github.io/">React-Bootstrap</a>, and <a href="https://www.npmjs.com/package/react-router-dom">React-Router-Dom</a>. React.js is a modern single-page application (<a href="https://en.wikipedia.org/wiki/Single-page_application">SPA</a>) JavaScript framework developed by Facebook and Instagram.
									      	</p>

									      	<Media>
						    						<Media.Left>
											        <img width={75} height={75} src={mediaImg_04} alt="Thumbnail 04" />
											      </Media.Left>

											      <Media.Body>
											      	<Media.Heading>React Routing</Media.Heading>
											      	<p style={fontSize}>
											      		Routing is handled via anchor references custom parsed via react-router-dom path parameters  and dynamic component rendering preserving browser history - <a href="http://httpd.apache.org/docs/current/mod/mod_rewrite.html">mod_rewrite</a> is not being used in this portfolio.
											      	</p>
											      </Media.Body>
						    					</Media>

									      </Media.Body>
				    					</Media>

				    					{ /* [End Inner Media] */ }

			    					</Media>
			    				</p>
		    				</Panel>
	    				</Col>
    				</Row>

		    		<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Innovation and Invention">
		    					Creativity, Innovation, and Invention - This is truly where I thrive beginning with my patent work at IBM designing a <a href="https://en.wikipedia.org/wiki/Steganography">steganography</a> inspired compression and encryption protocol using pixel color densities as well as offsets within images to encode and compress information to my most recent data science and cryptology software statistically modeling biomedical informatics-based data to help describe, model, and correlate clinical data. Along the way, I invented a robust very fast web server and <a href="/index.html#page=LMS">learning management system</a>.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Leadership Style">
		    					My leadership style is influenced from my project management professional training (PMP) with emphasis on engineering task/activity based assignments. In terms of Software Engineering, I have working knowledge and experience with SCRUM and subscribe to an incremental approach exemplified by the <a href="https://en.wikipedia.org/wiki/Spiral_model">Spiral Lifecycle Model</a>. I believe in making a human connection with my team and work to enhance capabilities throughout the organization; I am, in general, hand-offs in terms of direct management and strive to build maximum potential.
		    				</MarketingBlock>
		    			</Col>
		    		</Row>

						<Row>
		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Chief Engineer">
		    					Chief engineer, architect, and executive manager for planning, budgeting and deploying a comprehensive heterogeneous Windows &amp; Solaris UNIX <a href="/index.html#page=ITBuildOut">IT infrastructure</a> with Cisco equipment throughout the networking stack over a Class-3 public subnet and fractional Class-3 corporate subnet with automation a cornerstone of my leadership. The original thrust for automation began as a project to aid budget conditions during <a href="http://www.riotinto.com/">Rio Tinto</a> engineering by allowing more of our computer-based training budget to shift toward engineering.
		    				</MarketingBlock>
		    			</Col>

		    			<Col xs={12} md={6}>
		    				<MarketingBlock header="Technology Roadmaps">
		    					I have a number of years leading complete information technology architectural build-outs including startup experience and considerable experience with several complete production software products under my belt. With respect to roadmaps, I emphasize a three-year window of relevance with incremental modifications to planned missions and an overall goal of market penetration for planned products within a five year window. I prefer a hybrid management model combining aspects of <a href="https://en.wikipedia.org/wiki/Agile_software_development">Agile</a> with the Spiral Model of Software Development.
		    				</MarketingBlock>
		    			</Col>
		    		</Row>
	    		</div>
	    	</Grid>

	    	
	    	<Grid className="blockpadding">
	    		<div className="well">
	    			<Row>
			    		<Col xs={12} md={12}>
			    			<MarketingBlock header="Medicine, Engineering, Physics, &amp; Cryptology">
			    				<span>
			    					<b>
			    						What is uncertainty? In terms of medicine and engineering speaking specifically to informatics and analysis, it is one technique to identify which measurements are more meaningful to analysis by illustrating those measurements that contain variability and noise. It also provides a lens into the data itself where potential biases can be identified. I believe that when a cryptosystem cannot be sufficiently enumerated, a generalized theoretical cryptosystem can be assumed in the absence of an absolute cryptosystem.
			    					</b>
			    				</span>
			    				<hr/>
		    					<span>
		    						It's long been the science of cryptography and cryptology to remain in the shadows of secrecy; however, certain aspects of this science can be fruitfully applied to other disciplines. For example, in the spectrum of <a href="https://www.llnl.gov/">quantum physics</a>, with respect to <a href="https://en.wikipedia.org/wiki/Measurement">measurements</a> and <a href="https://en.wikipedia.org/wiki/Uncertainty">uncertainty</a>, we can describe a <a href="https://en.wikipedia.org/wiki/Cryptosystem">cryptosystem</a> as all possible states a particle can be in at any one given time. As we investigate and experiment, each captured state of this system illustrates the cipher text where one can apply <a href="https://en.wikipedia.org/wiki/Entropy_(information_theory)">entropy</a> and <a href="https://en.wikipedia.org/wiki/Redundancy_(information_theory)">language redundancy</a> to describe both absolute and relative uncertainty between each measured variable.
		    					</span>
		    					<hr/>
		    					<span>
		    						"The fourth and perhaps most important difference is this: we are concerned to distinguish artifacts from real objects ... are they artifacts of the physical system or are they structure present in the specimen itself? [1, p.202]" My position is that cryptology can aid in this task.
		    					</span>
		    				</MarketingBlock>
			    		</Col>
		    		</Row>

		    		<Row>
			    		<Col xs={12} md={12}>
			    			<p>
			    				[1] Hacking, I., Representing and intervening : introductory topics in the philosophy of natural science. 1983, Cambridge Cambridgeshire ; New York: Cambridge University Press. xv, 287 p.
			    			</p>
			    		</Col>
		    		</Row>
	    		</div>
	    	</Grid>

    	</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default Home;

/*
<ButtonGroup>
	<center>
	</center>
</ButtonGroup>
*/


// WEBPACK FOOTER //
// ./src/cba/appspec/body/Home.js